import React from "react";
import { Pagination as BSPagination } from "react-bootstrap";

const Pagination = props => {
  const { pageSize, currentPage, totalCount, onPageChange } = props;
  const totalPageCount = Math.ceil(totalCount / pageSize);

  const getPages = () => {
    const pages = [];
    const maxPagesToShow = 5;
    const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

    let startPage = Math.max(currentPage - halfMaxPagesToShow, 1);
    let endPage = Math.min(currentPage + halfMaxPagesToShow, totalPageCount);

    if (startPage === 1) {
      endPage = Math.min(startPage + maxPagesToShow - 1, totalPageCount);
    }
    if (endPage === totalPageCount) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <BSPagination>
      {currentPage > 1 && totalPageCount > 3 && (
        <>
          <BSPagination.First
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
          />
          <BSPagination.Prev
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
        </>
      )}

      {getPages().map((page, index) => (
        <BSPagination.Item
          key={index}
          active={currentPage === page}
          onClick={() => onPageChange(page)}>
          {page}
        </BSPagination.Item>
      ))}

      {currentPage < totalPageCount && totalPageCount > 3 && (
        <>
          <BSPagination.Next
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPageCount}
          />
          <BSPagination.Last
            onClick={() => onPageChange(totalPageCount)}
            disabled={currentPage === totalPageCount}
          />
        </>
      )}
    </BSPagination>
  );
};

export default Pagination;
